<template>
  <v-container class="gray-wrapper" fluid>
    <div class="config-title">
      <router-link to="/config/point" class="back-icon">
        <v-btn icon large>
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">
        {{ $t('point.exchangeApplication') }}
      </div>
    </div>
    <div style="display:none;">
      <v-numeric
        type="number"
        :precision="2"
        :min="0"
        :max="100000000000"
        v-model="amount"
        :rules="amountRules"
        required
      ></v-numeric>
    </div>
    <div class="form-wrapper">
      <div>
        <v-form ref="form" v-model="valid" lazy-validation>
          <span class="text-subtitle-2 font-weight-bold">{{
            $t('point.exchangeAmount')
          }}</span>

          <v-text-field
            :placeholder="$t('point.amountPlaceholder')"
            type="number"
            clearable
            v-model="amount"
            :rules="amountRules"
            required
            color="#4472D9"
            class="mt-0 pt-1"
          >
            <template slot="append">
              <div style="height:24px;display:flex;align-items:center;">
                PLI
              </div>
            </template>
          </v-text-field>
        </v-form>
        <div class="d-flex justify-end mb-5">
          <v-btn
            v-for="item in [10, 25, 50, 100]"
            :key="item"
            text
            tile
            color="black"
            class="per-btn"
            @click="onClickPer(item)"
            >{{ item === 100 ? $t('point.amountMax') : item + '%' }}</v-btn
          >
        </div>
        <div class="fee-box pa-5">
          <div class="d-flex justify-space-between align-center">
            <span class="font-46 fee-label error--text">
              {{ $t('point.availablePli') }}</span
            >
            <span class="font-46 font-weight-medium error--text"
              >{{ pli }} PLI</span
            >
          </div>
          <div class="d-flex justify-space-between align-center">
            <span class="font-46 fee-label"> {{ $t('point.fee') }}</span>
            <span class="font-46 fee-label font-weight-medium"
              >{{ fee }} PLI</span
            >
          </div>
        </div>
      </div>
      <div class="d-flex justify-space-between align-center pa-5">
        <div class="d-flex flex-column font-46 font-weight-bold">
          <span>{{ $t('point.totalAmount') }}</span>
          <span class="font-40" style="color:#A3A3A3;">{{
            $t('point.includeFee')
          }}</span>
        </div>
        <div class="text-h6">{{ total }} PLI</div>
      </div>
    </div>
    <div>
      <v-btn
        @click="openConfirmModal"
        tile
        block
        x-large
        depressed
        color="#4472D9"
        height="56px"
        dark
        class="bottom-btn"
        :disabled="loading || disabled"
      >
        {{ $t('point.exchangeApplication') }}
      </v-btn>
    </div>

    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          v-html="message"
          style="min-height: 5rem;display: flex;align-items: center;justify-content: center;"
        >
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <!-- <v-divider vertical></v-divider> -->
          <v-btn
            color="primary"
            width="50%"
            text
            x-large
            @click="messageModal = false"
            class="font-weight-bold"
          >
            {{ $t('point.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="successModal" max-width="30rem">
      <v-card>
        <div class="d-flex flex-column align-center px-3">
          <div class="mt-5">{{ $t('point.successExchange') }}</div>
          <div class="text-h6 font-weight-bold my-8">
            {{ $t('point.totalAmount') + $t('point.includeFee') }} :
            {{ success.amount }} PLI
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text
            x-large
            @click="successModal = false"
            class="font-weight-bold"
          >
            {{ $t('point.close') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="#4270D5"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            :href="success.href"
            target="_blank"
          >
            {{ $t('point.detailResult') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmModal" persistent max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text class="d-flex flex-column align-start" style="width:100%">
          <div class="d-flex flex-column mb-1" style="width:100%">
            <span>{{ $t('point.totalAmount') + $t('point.includeFee') }}</span>
            <span class="text-body-1 font-weight-medium"> {{ total }} PLI</span>
          </div>
          <div>{{ $t('point.confirmMessage') }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="confirmModal = false"
          >
            {{ $t('point.cancel') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="error"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="sendCall"
          >
            {{ $t('point.submitExchange') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BigNumber from 'bignumber.js'

export default {
  data() {
    return {
      gasFee: 0,
      valid: true,
      addressValid: true,
      confirmModal: false,
      successModal: false,
      success: {
        amount: 0,
        href: ''
      },
      txId: '',
      messageModal: false,
      message: null,
      amount: null,
      amountRules: [(v) => v >= 10000 || '', (v) => !!v || ''],
      disabled: false
    }
  },
  computed: {
    pli() {
      return this.$store.getters.wallet.filter((i) => i.name === 'PLI')[0]
        .balance
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    loading() {
      return this.$store.getters.loading
    },
    total() {
      return this.amount
        ? BigNumber(this.amount)
            .plus(BigNumber(this.fee))
            .toFormat({
              prefix: '',
              decimalSeparator: '.',
              groupSeparator: ',',
              groupSize: 3
            })
        : 0
    },
    fee() {
      return this.amount
        ? BigNumber(this.amount)
            .div(BigNumber('1000'))
            .toFixed(2, 1)
        : 0
    }
  },
  created() {
    this,
      (this.amountRules = [
        (v) => v >= 10000 || this.$t('point.amountError'),
        (v) => !!v || this.$t('point.amountNull')
      ]),
      this.$store.dispatch('balance_pli').then((res) => {
        // console.log(res, BigNumber.isBigNumber(res))
        if (!res.data || !res.data.status) {
          this.disabled = true
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: this.$t('errorServer'),
            timeout: 3000
          })
        }
      })
  },
  methods: {
    openConfirmModal() {
      // console.log(this.$refs.form.validate(), this.$refs.toAddress.validate())
      if (this.$refs.form.validate()) {
        this.confirmModal = true
      }
    },
    sendCall() {
      this.$store.commit('loading', true)
      this.confirmModal = false

      this.$store
        .dispatch('balance_pli')
        .then((res) => {
          if (res.data && res.data.status) {
            if (
              BigNumber(this.pli).isGreaterThanOrEqualTo(
                BigNumber(this.amount).plus(BigNumber(this.fee))
              )
            ) {
              const params = {
                senderAddress: this.myWalletAdress,
                valueAmount: this.amount
              }
              return this.$store.dispatch('exchange_pli', params)
            } else throw 'insufficient'
          } else throw res
        })
        .then((res) => {
          if (res.data && res.data.status) {
            this.$store.commit('loading', false)
            this.success.amount = this.total
            this.success.href = `https://sidescan.luniverse.io/chains/${process.env.VUE_APP_CHAIN_ID}/transactions/${res.data.txHash}`
            this.successModal = true
            this.$refs.form.reset()
          } else if (res.data && res.data.error) throw res.data.error
          else throw res
        })
        .catch((err) => {
          this.$store.commit('loading', false)
          if (err === 'insufficient') {
            this.messageModal = true
            this.message = this.$t('point.insufficientError')
          } else if (err === 'xuser') {
            this.messageModal = true
            this.message = this.$t('point.xuserError')
          } else {
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg: this.$t('errorServer'),
              timeout: 3000
            })
          }
          this.$refs.form.reset()
        })
    },
    onClickPer(num) {
      // const tmp = BigNumber(this.pli)
      //   .times(BigNumber(num / 1000))
      //   .toFixed(2, 0)
      // const fee = BigNumber(tmp)
      //   .div(BigNumber('1000'))
      //   .toFixed(2, 1)
      if (num === 100) {
        const tmp = BigNumber(this.pli)
          .times(BigNumber(1000 / 1001))
          .toFixed(2, 0)
        const fee = BigNumber(tmp)
          .div(BigNumber('1000'))
          .toFixed(2, 1)
        if (tmp + fee > this.pli) {
          this.amount = BigNumber(this.pli)
            .times(BigNumber(1000 / 1001))
            .toFixed(2, 1)
        } else {
          this.amount = tmp
        }
      } else {
        this.amount = BigNumber(this.pli)
          .times(BigNumber(num / 100))
          .toFixed(2, 0)
      }
    }
  }
}
</script>

<style scoped>
.gray-wrapper {
  background-color: #fff;
}
.fee-label {
  color: #a3a3a3;
  font-family: 'Noto Sans KR', 'Roboto', sans-serif;
  font-weight: 500;
}
.fee-box {
  background-color: #f5f6f7;
}
.form-wrapper {
  padding: 0 1.8rem 1.8rem 1.8rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 35rem;
  margin: 0 auto;
  overflow-y: auto;
  height: calc(100% - 133px);
}
.my-text-style >>> .v-messages__message {
  color: #4472d9;
}
.per-btn {
  border: 1px solid #dbdbdb;
  margin: 0.2rem;
}
</style>
